import { Cliente } from "@/shared/types/cliente";
import { NaturalezaReceptorEnum } from "@/shared/types/contribuyente";

export const getClienteDisplayValue = (persona: Cliente | undefined | null) => {
  if (persona && persona.naturaleza === NaturalezaReceptorEnum.Contribuyente) {
    return `${persona.nombre} (RUC: ${persona.ruc}-${persona.dv})`;
  } else if (persona) {
    return `${persona.nombre} (DOC: ${persona.numDocumento})`;
  } else {
    return "";
  }
}